export default server => {
    server.get('/v1/filters', () => {
        return [
            {
                id: 1,
                name: 'Squarespace positive',
                filter_type: 'twitter'
            },
            {
                id: 2,
                name: 'Squarespace negative',
                filter_type: 'twitter'
            }
        ];
    });
};
